<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">CONTENTS</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/chapter1#ch1">Three Lives</a></p>
<p class="toc"><a href="#/xhtml/part1#pt1"><span class="epub-b">A Perfect Failure</span></a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">No Such Word as Fail</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">To Fill Up Her Knowledge in all Directions</a></p>
<p class="toc"><a href="#/xhtml/chapter4#ch4">Bachelor Heiress</a></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">The Rumble of the Tumbrels</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">All Very Queer and a Little Depressing</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Too Late or Too Soon</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">The Sublime Governess</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">The Grave’s Intercom</span></p>
<p class="toc-bot"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample"><span class="epub-b">Fantasia on a Theme by Mercedes de Acosta</span></span></p>
<p class="toc"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample"><span class="epub-b">Velvet is Very Important</span></span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">I Absolutely Refused</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">I Was Free</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Who Need Never be Mentioned</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">To Remake My Career</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Professor of Fashion</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Notes on Discretion</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Looking is Not Vanishing</span></p>
<p class="toc"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/praise#pra" title="Link target outside of Sample">Praise for <span class="epub-i">All We Know</span></span></p>
<p class="toc"><span href="#/xhtml/list#list" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2cce0d3f